import apiClient from '../config/axiosConfig'; // eslint-disable-line

export const updateProjectVersionViaApi = (projectVersionModel, projectId) => {
    return apiClient.put(`/v2/projects/${projectId}/updatelatest`, projectVersionModel);
};

export const getLatestProjectVersionViaApi = (projectId) => { 
    return apiClient.get(`/v2/projects/${projectId}/versions/latest`); 
};

export const deleteProjectViaApi = (projectId) => {
    return apiClient.delete(`/v2/projects/${projectId}`);
};
